import { useCurrentUser } from "utils/hooks";
import { useNavigate } from "react-router-dom";
import { useQueryParams } from "utils/hooks";
import { useRef } from "react";

const useGuestRedirect = () => {
  const { user, isAuthenticated, isVerified, isTherapist } = useCurrentUser();
  const history = useNavigate();

  const { hasUrlParams } = useQueryParams();
  const nextUrl = hasUrlParams("next");
  const prevPathname = useRef(window.location.pathname);

  const redirect = () => {
    if (!isAuthenticated || !user) {
      return history("/login");
    }
    // if pinVerified === null we ignore it
    if (isTherapist && user?.pinVerified === false)
      history("/pin-verification");
    if (
      isAuthenticated &&
      !isVerified &&
      prevPathname.current !== "/verification"
    ) {
      return history("/verification");
    } else {
      if (nextUrl) {
        return history(nextUrl);
      }
    }
  };

  return {
    redirect,
  };
};

export default useGuestRedirect;
